import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-qualidade',
  standalone: true,
  imports: [MatToolbarModule, MatCardModule, MatButtonModule, RouterModule],
  templateUrl: './qualidade.component.html',
  styleUrl: './qualidade.component.scss',
})
export class QualidadeComponent {}
